import { render, staticRenderFns } from "./order_history.vue?vue&type=template&id=271253c8&scoped=true&"
import script from "./order_history.vue?vue&type=script&lang=js&"
export * from "./order_history.vue?vue&type=script&lang=js&"
import style0 from "./order_history.vue?vue&type=style&index=0&id=271253c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271253c8",
  null
  
)

export default component.exports